module.exports = __webpack_public_path__ + "static/media/Camera-icn.7e3b7a4b.svg";